import { Injectable } from '@angular/core';

import { HisBaseGlobalsService, DdEntryMerged } from 'hisng';

import { HISDDKEY_DEFAULT } from '../model/constants';

@Injectable()
export class DataDictionaryUtils {

    constructor( private hisBaseGlobalsService: HisBaseGlobalsService ) { }

    public static dDKeyPublicationType( typeValue: any, attr: string ) {
        return `fs.res.publication.PublicationType_${typeValue?.hiskeyId}.${attr}`;
    }

    /**
     * Prüft ob der DataDictionary-Eintrag für den gegebenen ddKey sichtbar ist.
     *
     * @param ddKey
     * @return true wenn sichtbar
     */
    public isVisible( ddKey: string ): boolean {
        let ddEntry: DdEntryMerged = this.hisBaseGlobalsService.getDd( ddKey );
        // note that getdD() returns null for DD entries that have only attributes set to false
        return !ddEntry || !ddEntry.hidden;
    }

    /**
     * Prüft ob der DataDictionary-Eintrag für den gegebenen ddKey versteckt ist.
     *
     * @param ddKey
     * @return true wenn versteckt
     */
    public isHidden( ddKey: string ): boolean {
        return this.hisBaseGlobalsService.getDd( ddKey )?.hidden;
    }

    /**
     * get the information about visibility via hisBaseGlobalsService of cached data dictionary entries
     *
     * @param hiskeyIds array containing all relevant hisDdKeys for tabView component
     */
    public isPanelVisible( hiskeyIds: number[] ): boolean {
        for ( let hiskeyId of hiskeyIds ) {
            if ( this.isVisible( HISDDKEY_DEFAULT + hiskeyId ) ) {
                return true;
            }
        }
        return false;
    }

    /* find hiskeyId not hidden by data-dictionary */
    public getNotDdHiddenHiskeyIds( hiskeyIds: number[] ): number[] {
        // remove hiskeyIds where data dictionary entry is hidden
        hiskeyIds.forEach( hiskeyId => {
            if ( this.isHidden( HISDDKEY_DEFAULT + hiskeyId ) ) {
                let indexOfHiskeyID = hiskeyIds.indexOf( hiskeyId );
                hiskeyIds[indexOfHiskeyID] = null; // replace hidden DD-Entries so we can render dynamic content
            }
        } );
        return hiskeyIds;
    }
}
